import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
import { HomePage } from '../home/home';

/**
 * Generated class for the ForgotMobileNumberPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-forgot-mobile-number',
  templateUrl: 'forgot-mobile-number.html',
})
export class ForgotMobileNumberPage {
  account_number: any;
  errorDisplay: any={};
  dob:any;
  constructor(
    private loadingCtrl:LoadingController,
    public navCtrl: NavController, public navParams: NavParams,
    private cp:CommonProvider,private fv:GenericFormValidationProvider) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad ForgotMobileNumberPage');
  }
  postFormForValidation(){
    
    
    this.errorDisplay=this.fv.checkValidationFormAllControls(document.forms[1],true,[]);
    //console.log(this.errorDisplay);
    if(this.errorDisplay.valid){
      return false;
    }else{
      let loading = this.loadingCtrl.create({
      content: 'Please wait...'
      });
       if(this.navParams.get("mobile")){
        try {
          loading.present()
          let loginResponce = this.cp.doLogin(loading,this.navParams.get("mobile"),this.account_number);
          loginResponce.then((res:any)=>{
            loading.dismiss()
            var res=JSON.parse(res)
            if(res.Payload.responseMessage=="SUCCESS"){
              this.navCtrl.setRoot(HomePage);
            }else{
              alert("Invalid Credencials,Please try again!");
            }
            
          }).catch(err => {
            //console.log(err);
            
            alert("Invalid Credencials,Please try again!")})
        } catch (error) {
          alert("Invalid Credencials,Please try again!");

          
        }  
        
       }else{
        alert("Mobile number is required");
       }
    }
    
    }

}



// WEBPACK FOOTER //
// ./src/pages/forgot-mobile-number/forgot-mobile-number.ts